import classNames from "classnames";
import React from "react";

import BlinkingOnClickComponent from "../BlinkingOnClickComponent/BlinkingOnClickComponent";
import { KeyboardButton } from "../Keyboard";

// tslint:disable-next-line:no-var-requires
const style = require("./NumPadKeyboardLayout.scss");

function renderButton(char: string) {
    return (
        <BlinkingOnClickComponent activeClassName={style.active}>
            <KeyboardButton button={{ char }}>{char}</KeyboardButton>
        </BlinkingOnClickComponent>
    );
}

export function NumPadKeyboardLayout() {
    return (
        <div className={classNames(style.numKeyboard)}>
            <div>
                {renderButton("1")}
                {renderButton("2")}
                {renderButton("3")}
            </div>
            <div>
                {renderButton("4")}
                {renderButton("5")}
                {renderButton("6")}
            </div>
            <div>
                {renderButton("7")}
                {renderButton("8")}
                {renderButton("9")}
            </div>
            <div>
                <BlinkingOnClickComponent activeClassName={style.active}>
                    <KeyboardButton
                        className={classNames(style.btn, style.lighterBtn)}
                        button={{ char: "," }}
                    >
                        {","}
                    </KeyboardButton>
                </BlinkingOnClickComponent>
                {renderButton("0")}
                <BlinkingOnClickComponent activeClassName={style.active}>
                    <KeyboardButton
                        className={classNames(style.btn, style.lighterBtn)}
                        button={{ char: "\b" }}
                    >
                        &#8678;
                    </KeyboardButton>
                </BlinkingOnClickComponent>
            </div>
        </div>
    );
}
